var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 968 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.75,166.39c17.98,17.98,41.61,26.98,65.23,26.98s47.25-8.99,65.23-26.98l84.33-84.33-21.1-21.1-84.33,84.33c-24.33,24.33-63.93,24.33-88.26,0l-1.25-1.25c-24.33-24.33-24.33-63.93,0-88.26l1.07-1.07c24.33-24.33,63.93-24.33,88.26,0l7.27,7.27,21.1-21.1-7.27-7.27C126.06-2.36,67.54-2.36,31.57,33.61l-1.07,1.07c-35.97,35.97-35.97,94.49,0,130.46l1.25,1.25Z",
    style: {
      fill: "#ff6a4c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.04,33.61c-17.98-17.98-41.61-26.98-65.23-26.98-23.62,0-47.25,8.99-65.23,26.98l-84.33,84.33,21.1,21.1,84.33-84.33c24.33-24.33,63.93-24.33,88.26,0l1.25,1.25c24.33,24.33,24.33,63.93,0,88.26l-1.07,1.07c-24.33,24.33-63.93,24.33-88.26,0l-7.27-7.27-21.1,21.1,7.27,7.27c35.97,35.97,94.49,35.97,130.46,0l1.07-1.07c35.97-35.97,35.97-94.49,0-130.46l-1.25-1.25Z",
    style: {
      fill: "#ff6a4c",
      strokeWidth: 0
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t    .st0{fill:#04242d;stroke-width: 0px;}\n    "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.96,36.81c27.99,0,39.3,20.7,39.3,41.22s-11.31,41.22-39.3,41.22h-35.08v49.65h-17.45V36.81h52.53ZM466.81,102.95c16.49,0,23-12.27,23-24.92s-6.33-25.11-22.05-25.11h-34.89v50.04h33.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M601.58,168.9l-34.7-49.84h-17.06v49.84h-17.45V36.81h49.65c28.76,0,39.88,20.7,39.88,41.22,0,19.17-10.93,39.49-34.51,41.22l35.08,49.65h-20.9ZM549.81,52.91v50.23h27.61c19.36,0,27.03-10.16,27.03-25.11s-8.63-25.11-22.05-25.11h-32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M650.84,168.9V36.81h17.45v132.09h-17.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M696.28,131.52h17.25c.58,11.69,11.69,23.58,29.33,23.58s26.65-11.12,26.65-22.81c0-12.84-11.69-18.6-22.81-21.47l-17.06-4.22c-27.99-6.71-32.4-23.2-32.4-33.93,0-22.81,20.51-38.15,43.52-38.15s41.79,14.76,41.79,38.34h-17.25c0-13.23-10.93-22.24-25.11-22.24-13.23,0-25.5,8.82-25.5,21.86,0,4.6,1.53,13.8,19.17,18.4l17.25,4.6c22.43,5.94,35.85,17.45,35.85,36.23,0,20.51-16.68,39.49-44.09,39.49s-46.39-19.17-46.59-39.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M964.48,168.9h-17.06l-12.27-100.65-41.98,86.27h-15.15l-42.37-86.27-12.08,100.65h-17.06l16.1-132.09h15.72l47.16,97.96,46.97-97.96h15.72l16.29,132.09Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrism);
export default __webpack_public_path__ + "static/media/Prism.677abb546fdfa42cb956ae5ff725e9bd.svg";
export { ForwardRef as ReactComponent };